export default {
  en: {
    trialHeader: 'Trial ended',
    endedTitle: 'Your trial has ended',
    endedDescription:
      "Thank you for trialling Risk Ledger. If you'd like to continue using Risk Ledger, let your Account Executive know.",
    contact: 'Contact us',
    contactAE: 'Our trial has ended 👋',
    trial: 'Trial',
    remainingDays: '1 day remaining | {n} days remaining',
    trialTitle: 'Risk Ledger trial',
  },
};
